import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/empleado/getEmpleados.php';

export default function getEmpleados({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}